import { useCallback } from 'react';
import { useEditSceneModalStateContext } from './EditSceneModalStateContext';
import {
  isBackgroundBlurDirtySelector,
  isBackgroundBlurEnabledSelector,
} from './selectors';

export default function useBackgroundBlur() {
  const { dispatch, state } = useEditSceneModalStateContext();

  const isBackgroundBlurEnabled = isBackgroundBlurEnabledSelector(state);
  const isBackgroundBlurDirty = isBackgroundBlurDirtySelector(state);

  const handleBlurChange = useCallback(
    (isActive: boolean) => {
      dispatch({
        type: 'toggle-blur',
        payload: {
          isActive,
        },
      });
    },
    [dispatch],
  );

  return {
    isBackgroundBlurEnabled,
    isBackgroundBlurDirty,
    handleBlurChange,
  };
}
